import keyMirror from '@kopapro-redux/utils/key-mirror';

export default keyMirror({
  GET_BONUS_POINTS_SETUP_REQUEST: null,
  RECEIVED_BONUS_POINTS_SSETUP: null,
});
